import { CdkCell, CdkCellDef } from '@angular/cdk/table';
import { Directive, HostBinding, Input } from '@angular/core';

/**
 * Cell definition for the table.
 * Captures the template of a column's data row cell as well as cell-specific properties.
 */
@Directive({
  selector: '[nCellDef]',
  providers: [{ provide: CdkCellDef, useExisting: NCellDefDirective }],
})
export class NCellDefDirective extends CdkCellDef {}

/** Cell template container that adds the right classes and role. */
@Directive({
  selector: 'n-cell, td[n-cell]',
})
export class NCellDirective extends CdkCell {
  @HostBinding('attr.class') cssClasses = 'n-cell';
  @HostBinding('attr.role') role = 'gridcell';
  @Input() set class(classNames: string) {
    this.cssClasses = `n-cell ${classNames ?? ''}`;
  }
}
